<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container my-5" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-div v-bind='{...{},...{}}' :style='""' class="text-center mb-5 mx-auto" >
                <template #default>   <m-img v-bind='{...{"src":"https:\/\/api.saramadhome.ir\/storage\/icons\/IDLj9yrMMDk9NbqcivaTIttD9egGZo4jVPaO9Unb.png","alt":"saramadhome"},...{}}' :style='"width:250px;height;auto"' class="" ></m-img></template>
                </m-div><m-h4 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>فرم ثبت نام مجموعه مدارس دخترانه سرآمد   </template>
                </m-h4><m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   </template>
                </m-div><m-h5 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>آموزش سرآمد، پرورش کارآمد، انسان باکرامت، حیات با سعادت   </template>
                </m-h5><m-h5 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>دبستان وپیش دبستان|دبیرستان دوراول    </template>
                </m-h5><m-h5 v-bind='{...{},...{}}' :style='""' class="text-center" >
                <template #default>مدیر وموسس: فرحناز عنایتی   </template>
                </m-h5><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>سوابق اجرایی وآموزشی:
   </template>
                </m-h5><m-ul v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>معاون اموزش وپرورش ناحیه سه اهواز
   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>کارشناس اموزشی ناحیه 4اهواز   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>سابقه بیش از20سال مدیریت واموزش در مقاطع مختلف استان     </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>مولف ونویسنده: بیش از بیست کتاب ودفتر مشق مجموعه کتابهای سرآمد    </template>
                </m-li></template>
                </m-ul><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default> ظرفیت محدود:   </template>
                </m-h5><m-ul v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>پذیرش متوسطه اول از طریق ازمون ومصاحبه   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>دبستان وپیش دبستان از طریق مصاحبه    </template>
                </m-li></template>
                </m-ul><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default> ویژگی های مدرسه:   </template>
                </m-h5><m-ul v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>اموزشهای مهارت محوربا سبک نوین اموزشی وپرورشی   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>فضای مناسب ومجهز   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>کادرمجرب واستفاده از دبیران رسمی اموزش وپرورش با سابقه کار درمدارس تیزهوشان، نمونه دولتی    </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>برگزاری کلاسهای فوق برنامه   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>برگزاری کلاسهای تست زنی 
   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>کلاسهای کاملا هوشمند 
   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>برخوردار ازمشاور وپشتیبان تحصیلی ومهارتی 
   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>
خدمات اموزشی متنوع شامل برگزاری ازمونهای شبیه ساز تیزهوشان، نمونه دولتی، پیشرفت تحصیلی وازمونهای مستمر کلاسی
   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>کلاسهای آموزش خانواده
   </template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>برگزاری اردوهای علمی وتفریحی    </template>
                </m-li></template>
                </m-ul><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>تلفن:   </template>
                </m-h5><m-ul v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-a v-bind='{...{"href":"tel:09165421996","target":"_self"},...{}}' :style='""' class="d-block" >
                <template #default>09165421996   </template>
                </m-a></template>
                </m-li><m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-a v-bind='{...{"href":"tel:09038210077","target":"_self"},...{}}' :style='""' class="d-block" >
                <template #default>09038210077   </template>
                </m-a></template>
                </m-li></template>
                </m-ul><m-h5 v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>ادرس محل ثبت نام:   </template>
                </m-h5><m-ul v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>شعبه 1:پادادشهر خیابان 12غربی پلاک 56   <m-li v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>شعبه 2:پادادشهر خیابان 13پلاک 19
   </template>
                </m-li></template>
                </m-ul></template>
                </m-div><m-div v-bind='{...{},...{}}' :style='""' class="" >
                <template #default>   <m-form-single-1 v-bind='{...{"itemClass":"col-lg-12 mb-3","formId":1,"redirectToDashboard":false,"redirectDirectLink":"https:\/\/saramadhome.ir\/registration-form-callback"},...{}}' :style='""' class="" ></m-form-single-1></template>
                </m-div></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mImg from '@moeinmdn/miw-alpha-components/src/package/Tags/Img'; import mH4 from '@moeinmdn/miw-alpha-components/src/package/Tags/H4'; import mH5 from '@moeinmdn/miw-alpha-components/src/package/Tags/H5'; import mUl from '@moeinmdn/miw-alpha-components/src/package/Tags/Ul'; import mLi from '@moeinmdn/miw-alpha-components/src/package/Tags/Li'; import mA from '@moeinmdn/miw-alpha-components/src/package/Tags/A'; import mFormSingle1 from '@moeinmdn/miw-alpha-components/src/package/Form/FormSingle/FormSingle1';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mImg,mH4,mH5,mUl,mLi,mA,mFormSingle1 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
